import React, { useEffect, useRef, useState } from 'react'
import svgImagesString from '../../../../svg/svg3d.json';
import Icon from '../../../../../asset/plus.png'
import { decimalToDMS, decimalToUTM } from '../../../../component/main-ui/common/commonfunctions'
import rightIcon from '../../../../asset/rightIcon.png'
import downIcon from '../../../../../asset/down.png'
import { ColorCodes } from '../../../main-ui/left-toolbar/common/marker-details/dummy';
import standIconWhite from '../../../../asset/Tree_Stand_White.png'
import { store } from '../../../../lib/store'
import { expandLeftToolbar } from '../../../../action/left-toolbar-state-actions';
import { dateConvertion } from '../../../../component/main-ui/common/commonfunctions';

export const buildMarkerTemplate = (svgId = 134, color, index) => {
  const colorMarker = color?.replace(/^#?([a-fA-F0-9]{6}).*$/, '#$1') || '#9ECC3B';

  const template = document.createElement("template");

  template.innerHTML = `
    <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50">
      <defs>
        <clipPath id="circleClip">
          <circle cx="8" cy="6" r="5" />
        </clipPath>
      </defs>

      <!-- Pin shape path with colored fill -->
      <path
        d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z
           M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3S9.656,8,8,8z"
        fill="${colorMarker}" />

      <!-- White circle inside -->
      <circle cx="8" cy="6" r="5" fill="#FFFFFF" />

      <!-- Centered icon inside white circle -->
      <g x="8" y="6"
        transform="translate(${svgImagesString[svgId]?.right ?? 8},
                             ${svgImagesString[svgId]?.top ?? 6})
                 scale(${svgImagesString[svgId]?.size ?? 0.35})
                 translate(${svgImagesString[svgId]?.left ?? -11},
                           ${svgImagesString[svgId]?.bottom ?? -8})">
        ${svgImagesString[svgId]?.svgCode ?? svgImagesString[134]?.svgCode}
      </g>
    </svg>
  `;

  return template;
};

export const buildBluePin = () => {
  const template = document.createElement("template");

  template.innerHTML = `
     <svg class="default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20">
      <defs>
        <clipPath id="circleClip">
          <circle cx="8" cy="6" r="5" />
        </clipPath>
      </defs>

      <!-- Pin shape path with colored fill -->
      <path
        d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z
           M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3S9.656,8,8,8z"
        fill="#4285F4" />

      <!-- White circle inside -->
      <circle cx="8" cy="6" r="5" fill="#4285F4" />  
    </svg>
  `;

  return template;
};

export const buildphotoMarkerTemplate = (color) => {
  let colorMarker
  if (color.length <= 6 || color.length <= 7) {
    colorMarker = color[0] == '#' ? color : '#' + color
  } else {
    colorMarker = color[0] == '#' ? color.substring(2) : '#' + color.substring(2)
  }

  const fallbackUrl = "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/June_odd-eyed-cat.jpg/300px-June_odd-eyed-cat.jpg";

  const template = document.createElement("template");
  template.innerHTML = `    
<svg width="40" height="50" viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <!-- Clip path for inner circle -->
    <clipPath id="circleClip">
      <circle cx="20" cy="20" r="15" />
    </clipPath>
  </defs>

  <!-- Outer circle (border) -->
  <circle cx="20" cy="20" r="17" fill=${colorMarker} />

  <!-- Inner circle background -->
  <circle cx="20" cy="20" r="15" fill=${colorMarker} />

  <!-- Inner SVG clipped to circle -->
  <g clip-path="url(#circleClip)">
    <svg x="5" y="5" width="30" height="30" viewBox="0 0 600 600">
      <defs>
        <clipPath id="circleInner">
          <circle cx="300" cy="300" r="300" />
        </clipPath>
      </defs>
      <g clip-path="url(#circleInner)">
        <!-- Sky -->
        <rect width="600" height="600" fill="#7fe6ff"/>
        <!-- Sun -->
        <circle cx="150" cy="150" r="50" fill="#ffeb00"/>
        <!-- Left Mountain -->
        <polygon points="0,600 200,300 400,600" fill="#6af74f"/>
        <!-- Right Mountain -->
        <polygon points="200,600 450,200 600,600" fill="#32a632"/>
      </g>
    </svg>
  </g>

  <!-- Downward triangle (pointer) -->
  <polygon points="20,47 12,35 28,35" fill=${colorMarker} />
</svg>

  `;
  return template;
};

export function MakeTextInput(props) {
  const {
    name,
    width,
    access,
    marginLeft,
    containerWidth,
    displayVal,
    userPreferences,
    onChange,
    latVal,
    lngVal,
  } = props;

  const heloValue = displayVal && displayVal.length > 2 ? displayVal : '';
  const dmsValue =
    heloValue &&
    (name === 'latitude' || name === 'longitude') &&
    decimalToDMS(heloValue, name === 'latitude');
  const utmValue = name === 'latitude' && latVal && lngVal ? decimalToUTM(latVal, lngVal) : '';

  const getValue = () => {
    if (name === 'latitude' || name === 'longitude') {
      if (userPreferences.coordinates === 'dms') {
        return dmsValue;
      } else if (userPreferences.coordinates === 'utm') {
        return utmValue;
      } else {
        return heloValue;
      }
    }
    return heloValue;
  };

  return (
    <div
      style={{
        width: containerWidth || width,
        height: 68,
        marginTop: 10,
        marginLeft,
      }}
      key={`markerInput-${name}`}
    >
      <label
        htmlFor={name}
        className="label-style"
        style={{
          fontSize: '12px',
          textTransform: 'capitalize',
        }}
      >
        {`${name}:`}
      </label>

      <input
        type="text"
        name={name}
        id={name}
        style={{
          background: '#333333',
          opacity: 1,
          marginTop: '5px',
          width: access ? width : '84%',
          height: 40,
          border: 'none',
          borderRadius: 5,
          padding: '0 10px',
          color: 'white',
        }}
        placeholder={name}
        readOnly={
          (name === 'latitude' || name === 'longitude') &&
          (userPreferences.coordinates === 'dms' || userPreferences.coordinates === 'utm')
        }
        value={getValue()}
        onChange={(e) => onChange(name, e.target.value)}
      />
    </div>
  );
}

export function NewMarkerIconStyle({
  dropdownHeight,
  backgroundColorProp,
  iconProp,
  markerGroups,
  type,
  leftToolbarState,
  setIconUrl,
  recentUsedMarkers,
  selectedStyle,
  typeOfProp,
  selectAnimal,
  selectColor,
  colorMarker,
  markerTypeId,
  locationName,
  openStyleIcon,
  setOpenStyleIcon,
  setSelectedStyle,
  setFilterItems,
}) {
  const { editable, mapObj } = leftToolbarState;
  const gridContainerStyle = {
    marginTop: "5px",
    display: "grid",
    gap: "8px",
    alignItems: "center",
    justifyItems: "center",
  };

  let standFilterData = [];
  if (type == "addStand") {
    markerGroups.forEach((value) => {
      value.markerType.forEach((item) => {
        if (item.usageFlag == 3) { standFilterData.push(value) };
      });
    });
  }

  const uniqueArray = Array.from(new Set(standFilterData.map(JSON.stringify))).map(
    JSON.parse
  );

  const markerGroupsArray =
    type == "addStand" ? uniqueArray : markerGroups;
  // color adjustment logic
  let markerDisplayColor = "#9ECC3B";
  if (backgroundColorProp) {
    if (backgroundColorProp.length <= 6) {
      markerDisplayColor =
        backgroundColorProp[0] == "#"
          ? backgroundColorProp
          : "#" + backgroundColorProp;
    } else {
      markerDisplayColor =
        backgroundColorProp[0] == "#"
          ? backgroundColorProp
          : "#" +
          backgroundColorProp.substring(
            backgroundColorProp.length == 7 ? 1 : 2
          );
    }
  }
  return (
    <div>
      <label className="label-style">Styles</label>
      <div
        className="marker-icon-style-container"
        style={{ backgroundColor: openStyleIcon ? "white" : "#333333", height: `calc(110px + ${dropdownHeight}px)` }}
      >
        <div className="marker-icon-div">
          <div
            className="open-style-icon"
            onClick={() => setOpenStyleIcon((prev) => !prev)}
          >
            <img
              src={openStyleIcon ? downIcon : rightIcon}
              alt="toggle"
              style={{ width: 17, height: 18, cursor: 'pointer' }}
            />
          </div>

          <div className="color-marker-style">
            <svg
              width="55px"
              height="55px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <clipPath id="circleClip">
                  <circle cx="8" cy="6" r="5" />
                </clipPath>
              </defs>
              <rect width="16" height="16" fill="none"></rect>
              <path
                d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3S9.656,8,8,8z"
                fill={'#' + colorMarker}
              ></path>
              <circle cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
              <image
                xlinkHref={iconProp}
                x="5"
                y="3"
                width="6"
                height="6"
                clipPath="url(#circleClip)"
              ></image>
            </svg>
            <h6
              style={{
                font: "normal normal normal 15px/20px Roboto",
                color: openStyleIcon ? "#333333" : "white",
              }}
            >
              {locationName}
            </h6>
          </div>
        </div>

        {openStyleIcon && (
          <div style={{ height: dropdownHeight, marginTop: 10, marginLeft: 10 }}>
            {/* COLORS */}
            <div
              className="select-color-container"
              style={{
                display: "flex",
                flexWrap: "wrap",
                height: "90px",
                width: "96%",
                margin: "6px",
              }}
            >
              {ColorCodes.map((item, index) => (
                <div
                  key={index}
                  style={{
                    width: "calc(14.28% - 10px)",
                    height: "40px",
                    margin: "5px",
                  }}
                >
                  <div
                    className="selected-color"
                    onClick={() => {
                      selectColor(item)
                    }
                    }
                    style={{ backgroundColor: "#" + item }}
                  ></div>
                  <div
                    className={item == colorMarker ? "bottom-box" : ""}
                  ></div>
                </div>
              ))}
            </div>

            {/* ICONS */}
            <div
              className="marker-icons-style"
              style={{
                overflowY: type == "addStand" ? "hidden" : "scroll",
              }}
            >
              <label className="label-all-style">
                {type == "addStand"
                  ? "Hunt Stands"
                  : selectedStyle == "Recent"
                    ? `${selectedStyle} Used`
                    : selectedStyle}
              </label>

              {type == 'huntStand' && <div className="recent-use-container">
                {markerGroupsArray.map(
                  (item, index) =>
                    item.name == selectedStyle && (
                      <div key={index} className="scroll-container">
                        {item.markerType.map((value, i) => (
                          <div
                            key={i}
                            style={{
                              width: "60px",
                              height: 80,
                              marginTop: 8,
                              display: "row",
                            }}
                          >
                            <div className="recent-used-icon-div">
                              <div
                                className={
                                  markerTypeId == value.id
                                    ? "icon-style-effect-active"
                                    : "icon-style-effect"
                                }
                                onClick={() => setIconUrl(value.vectorIconUrl)}
                              >
                                <img
                                  src={value.vectorIconUrl}
                                  alt={value.name}
                                  style={{ width: "30px", height: "25px" }}
                                />
                              </div>
                              <span
                                className="recent-used-label"
                                style={{
                                  width: 60,
                                  height: "30px",
                                  textAlign: "center",
                                  color: "#333333",
                                }}
                              >
                                {value.name}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )
                )}
              </div>}
              <>
                <label className='label-all-style' >{type == 'huntStand' ? '' : 'All Styles'} </label>
                <div>
                  {markerGroupsArray.map((item, index) => {
                    let gridRowSize = item.markerType.length <= 4 ? 1 : item.markerType.length <= 8 ? 2 : item.markerType.length <= 12 ? 3 : item.markerType.length <= 16 ? 4 : item.markerType.length <= 20 ? 5 : item.markerType.length <= 24 ? 6 : item.markerType.length <= 28 ? 7 : 4
                    let heightGrid = item.name == "Wildlife" ? 1340 : item.name == "Hunting" ? 1040 : item.name == "Fishing" ? 550 : item.markerType.length <= 4 ? 80 : gridRowSize * 85
                    return (
                      <div key={index}>
                        {item.name != "Recent" && item.name != "Hunt Stands" ?
                          <div >
                            <a>
                              <div className='all-styles-container'
                                style={{ marginTop: 15 }}>
                                <span className="marker-styles-group-header" style={{}}>{item.name}</span>
                              </div>
                            </a>
                            <div style={{
                              ...gridContainerStyle,
                              height: heightGrid,
                              gridTemplateColumns: `repeat(${4}, 1fr)`, // 4 columns
                              gridTemplateRows: `repeat(${gridRowSize}, 1fr)`,
                            }}>
                              {item.markerType.map((value, index) => {
                                return (
                                  <div key={index} style={{ width: '60px', height: 80, marginTop: 8, display: 'row' }}>
                                    <div className='recent-used-icon-div' style={{ height: type == 'addStand' || typeOfProp == 'addStand' ? '80px' : '80px' }}>
                                      <div className={
                                        // this.state.markerTypeId == value.id ? 
                                        // 'icon-style-effect-active' :
                                        'icon-style-effect'}
                                        onClick={(e) => {
                                          e.preventDefault()
                                          selectAnimal(value)
                                          setIconUrl(value.vectorIconUrl)
                                        }}
                                      >
                                        <a >
                                          <img src={value.vectorIconUrl} style={{ width: '30px', height: ' 25px', }}></img>
                                        </a>
                                      </div>
                                      <span className='recent-used-label' style={{ width: type == 'addStand' || typeOfProp == 'addStand' ? 60 : 60, height: type == 'addStand' || typeOfProp == 'addStand' ? '30px' : '30px', textAlign: 'center', color: '#333333' }}>{value.name}</span>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                          :

                          <div key={index}>
                            <a>
                              <div className='all-styles-container'
                                style={{ marginTop: 15 }}>
                                <span className="marker-styles-group-header" style={{}}>{item.name}</span>
                              </div>
                            </a>
                            <div style={{
                              ...gridContainerStyle,
                              height: heightGrid,
                              gridTemplateColumns: `repeat(${4}, 1fr)`, // 4 columns
                              gridTemplateRows: `repeat(${gridRowSize}, 1fr)`,
                            }}>
                              {item.markerType.map((value, index) => {
                                return (
                                  <div key={index} style={{ width: '60px', height: 80, marginTop: 8, display: 'row' }}>
                                    <div className='recent-used-icon-div' style={{ height: type == 'addStand' || typeOfProp == 'addStand' ? '80px' : '80px' }}>
                                      <div className={
                                        // this.state.markerTypeId == value.id ? 
                                        // 'icon-style-effect-active' :
                                        'icon-style-effect'}
                                        onClick={(e) => {
                                          e.preventDefault()
                                          selectAnimal(value)
                                          setIconUrl(value.vectorIconUrl)
                                        }}
                                      >
                                        <a >
                                          <img src={value.vectorIconUrl} style={{ width: '30px', height: ' 25px', }}></img>
                                        </a>
                                      </div>
                                      <span className='recent-used-label' style={{ width: type == 'addStand' || typeOfProp == 'addStand' ? 60 : 60, height: type == 'addStand' || typeOfProp == 'addStand' ? '30px' : '30px', textAlign: 'center', color: '#333333' }}>{value.name}</span>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        }
                      </div>
                    )
                  })}
                </div>
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export function GetHeader(props) {
  return (
    <div className='left-expanded-header-container'>
      <span className='left-expanded-header'> {props.title + ' ' + props.titleName}</span>
      <div className='default-close left-dialog-close' onClick={props.collapseLeftToolbar}></div>
    </div>
  )
}

function handleShareButton(latitude, longitude, markerName, markerDetails) {
  const domain = process.env.NODE_ENV == 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'app.basemap.com' : 'staging.basemap.com'
  // Define email details
  const to = '';
  const subject = 'BaseMap Shared Marker';
  const body = `I've shared a marker with you, click below to view in the BaseMap app. https://${domain}/marker?latitude=${latitude}&longitude=${longitude}&t=63&n=${markerName}&c=${markerDetails} Don't have the app? Download here: https://app.basemap.com.`;

  // Create a mailto URL
  const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  // Open the default email client with the predefined details
  window.location.href = mailtoURL;
};

export function buildPhotoPopover(PopoverElement, markerObj, markerName, props, mapObj) {
  const popover = new PopoverElement();
  // popover.setAttribute("popover", "manual");
  popover.hide = () => { popover.style.display = "none"; };
  popover.style.display = "block";
  let colorMarker

  if (markerObj) {
    let color = markerObj.color
    let url = markerObj.markerType.vectorIconUrl
    const hasSpaces = url.includes(' ');
    if (color) {
      if (color.length <= 6) {
        colorMarker = color[0] == '#' ? color : '#' + color;
      } else {
        colorMarker = color[0] == '#' ? color : '#' + color.substring(color.length == 7 ? 1 : 2);
      }
    } else {
      colorMarker = '#9ecc3b';
    }
  }

  let removeMarker = () => {
    props.markerDeleteRequest(markerObj.id)
      .then((res) => {
        markerObj.mapObj.remove()
        markerObj.mapObj().map = null
        console.log('Marker removed and id :', markerObj.id)
      })
      .catch((err) => {
        console.log(`error while deleting id :${markerObj.id}`, err)
      })

  }

  // ✅ Log available ::part attributes
  // logAvailableParts(popover);

  // === Main Container ===
  const container = document.createElement("div");
  container.style.padding = "10px";
  container.style.height = "165px";
  container.style.width = "300px";
  container.style.backgroundColor = "#1d1d1d";
  container.style.visibility = "visible";
  container.style.borderRadius = "10px";

  // --- Header Section ---
  const headerContainer = document.createElement("div");
  headerContainer.className = "info-window-header-container";

  const headerLeft = document.createElement("div");
  headerLeft.id = "my-react-component-container";
  headerLeft.style.width = "90%";

  const headerDiv = document.createElement("div");
  headerDiv.className = "info-window-header-div";

  const heading = document.createElement("span");
  heading.className = "info-window-heading";
  heading.innerText = markerName;

  headerDiv.appendChild(heading);
  headerLeft.appendChild(headerDiv);

  const closeDiv = document.createElement("div");
  closeDiv.className = "info-window-closeicon";

  const closeLink = document.createElement("a");
  closeLink.id = "close";

  const closeImg = document.createElement("img");
  closeImg.src = "/asset/close.png";
  closeImg.alt = "Close";
  closeImg.style.width = "20px";
  closeImg.style.objectFit = "cover";
  closeImg.style.float = "right";
  closeImg.style.marginTop = "-10px";

  closeLink.appendChild(closeImg);
  closeDiv.appendChild(closeLink);

  headerContainer.appendChild(headerLeft);
  headerContainer.appendChild(closeDiv);

  // --- Info Section ---
  const infoWrapper = document.createElement("div");
  infoWrapper.style.width = "100%";
  infoWrapper.style.display = "flex";
  infoWrapper.style.position = "relative";
  infoWrapper.style.zIndex = "111";
  infoWrapper.style.justifyContent = "center";

  const infoLeft = document.createElement("div");
  infoLeft.style.width = "90%";

  let onButtonClick = (markerObj) => {
    if (popover) {
      popover.open = false;  // ← the correct close method
    }
    store.dispatch(expandLeftToolbar({
      dialog: 'edit', editable: markerObj, mapObj: mapObj
    }));
  };

  const reduxState = store.getState();
  const { userPreferences } = reduxState;

  const formattedDate = markerObj?.created ? dateConvertion(markerObj.created) : 'NA'
  let altitudeValue = markerObj?.altitude ? (userPreferences.units == 'imperial' ? (markerObj.altitude * 3.28084).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ' + 'ft' : markerObj.altitude.toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ' + 'm') : 'NA';

  console.log(markerObj?.markerType.vectorIconUrl, '=================>markerObj.markerType.vectorIconUrl in render')


  infoLeft.innerHTML = `
  <div style="width: 100%; display: flex; position: relative; z-index: 111;">                
          <div style="width: 70%; ">
                <h6 class="info-box-head-date">Created : <span class="info-box-head-date">${formattedDate || "N/A"}</span></h6>
                <h6 class="info-box-head">Elev : <span class="info-box-span">${altitudeValue || "N/A"}</span></h6>
                <h6 class="info-box-head">Latitude : <span class="info-box-span">${markerObj?.latitude || 'NA'}</span></h6>
                <h6 class="info-box-head">Longitude : <span class="info-box-span">${markerObj?.longitude || 'NA'}</span></h6>
              <div style="width:100%; display:flex; margin-top:10px; margin-right:10px;justify-content: space-evenly;">
                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <a id="shareButton">
                          <div class="info-window-bottons">
                            <img style="width: 50%; height: 50%; object-fit: cover;" src="/asset/shared.png">
                          </div>
                        </a>
                      <p style="height: 15px;font-size:10px">Share</p>
                  </div>
                 
                <!--  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="deleteButtonThreed">
                        <div class="info-window-bottons">
                          <img style="width: 50%; height: 50%; object-fit: cover;" src="/asset/bin.png">
                        </div>
                      </a>                    
                      <p style="height: 15px;font-size:10px">Delete</p>
                  </div>  -->

                  <div
                      style="width: 25%; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <a id="editButtonThreed">
                        <div class="info-window-bottons">
                          <img style="width: 50%; height: 50%; object-fit: cover;" src="/asset/pencil.png">
                        </div>
                      </a>                    
                      <p style="height: 15px;font-size:10px">Edit</p>
                  </div> 

              </div>                
          </div>     
          
          
          <div style="width: 30%; display: flex; justify-content: center; ">        
              <svg class="info-marker-default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Define the clipping path for the circle -->
                  <defs>
                      <clipPath id="circleClip">
                          <circle cx="8" cy="6" r="5" />
                      </clipPath>
                  </defs>
                  <rect width="16" height="16" id="icon-bound" fill="none"></rect>
                  <path
                      d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z"
                      fill='${colorMarker || ' #ffffff'}'></path>
                  <circle class="" cx="8" cy="6" r="5" fill="#FFFFFF"></circle>
                  <!-- Image inside the circle with clipping path -->
                  <image xlink:href=${markerObj?.markerType.vectorIconUrl ? markerObj.markerType.vectorIconUrl : 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'} x="4" y="1.5"
                          width="8" height="8" clip-path="url(#circleClip)"></image>
              </svg>
          </div>    

  </div> 
  `

  // infoRight.appendChild(imageView);
  // infoWrapper.appendChild(infoRight);
  infoWrapper.appendChild(infoLeft);


  // Hook edit button
  const editBtn = infoLeft.querySelector("#editButtonThreed");
  if (editBtn) {
    editBtn.addEventListener("click", () => {
      onButtonClick(markerObj);
    });
  }

  let shareButton = infoLeft.querySelector("#shareButton")
  if (shareButton) {
    shareButton.addEventListener("click", () => {
      // latitude, longitude, markerName, markerDetails
      handleShareButton(markerObj?.latitude, markerObj?.longitude, markerObj?.markerName, markerObj);
    });
  }


  // Hook delete button
  const deleteBtn = infoLeft.querySelector("#deleteButtonThreed");
  if (deleteBtn) {
    deleteBtn.addEventListener("click", () => {
      removeMarker()
    });
  }


  // 🔗 close event
  closeLink.addEventListener("click", () => {

    popover.removeAttribute("open");

  });

  // === Assemble popup ===
  container.appendChild(headerContainer);
  container.appendChild(infoWrapper);
  // container.appendChild(triangleContainer);

  popover.appendChild(container);

  (function () {
    const origAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) {
      const shadow = origAttachShadow.call(this, init);
      if (this.tagName.toLowerCase() === "gmp-popover") {
        const style = document.createElement("style");
        style.textContent = `
        dialog {
          background-color: #1d1d1d !important;
          border-radius: 10px;
        }

        dialog:after {
         background-color: #1d1d1d !important;
        }
      `;
        shadow.appendChild(style);
      }
      return shadow;
    };
  })();

  return popover;
}